module.exports = __webpack_public_path__ + "static/media/logo.912fde71.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 140
// module chunks = 0